const ui = {
  theme: 'izzi',
  showLoader: false,
  language: 'ptBR',
};

export default ui;
